import { FunctionComponent, memo } from 'react';
import { ChartType } from '../Analytics';
import { useChartExclude } from '../helpers';
import { UserReferralActivity } from './UserReferralActivity';
import { UserReferralList } from './UserReferralList';

export interface ReferralProps {
  from: string;
  to: string;
}

export const Referral: FunctionComponent<ReferralProps> = memo((props) => {
  const excludeUserReferralActivity = useChartExclude(ChartType.USER_REFERRAL_ACTIVITY);
  const excludeUserReferralList = useChartExclude(ChartType.USER_REFERRAL_LIST);

  return (
    <>
      {!excludeUserReferralActivity && <UserReferralActivity {...props} />}
      {!excludeUserReferralList && <UserReferralList {...props} />}
    </>
  );
});
